module.exports = __webpack_public_path__ + "img/default-tango.f3573521.svg";